export const filterEndpoints = [
  {
    label: "All",
    endpoint: "initial_call/",
  },
  {
    label: "Completed",
    endpoint: "completed/",
  },
  {
    label: "In Progress",
    endpoint: "in_progress/",
  },
  {
    label: "Archived",
    endpoint: "archived/",
  },
];